export default __webpack_public_path__ + "static/media/checked_manual_run_status.7197789c.svg";